// extracted by mini-css-extract-plugin
module.exports = {"searchHeader":"SearchHeader_searchHeader__1vAgC","inputContainer":"SearchHeader_inputContainer__s6jxB","searchInput":"SearchHeader_searchInput__32CBm"};